import { MainSource } from '../../constants/Source';

export const generatePurchaseTab = (source: MainSource): string => `media-manager_${source}`;
